import { Fragment } from 'react';

import { splitTextWithUrls } from '@/app/(main)/calendar/utils/linkifyText';

type LinkifiedTextProps = {
  text: string;
};

export function LinkifiedText({ text }: LinkifiedTextProps) {
  const segments = splitTextWithUrls(text);

  return (
    <>
      {segments.map((segment, index) => {
        if (segment.type === 'text') {
          return <Fragment key={`text-${index}`}>{segment.value}</Fragment>;
        }

        return (
          <a
            key={`link-${index}-${segment.href}`}
            href={segment.href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-300 hover:underline"
          >
            {segment.value}
          </a>
        );
      })}
    </>
  );
}
